export const Crown = ({ secondaryColor = 'none' }: { secondaryColor?: string }) => (
  <svg width="24" height="24" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 1L14 7L19 3L17 13H3L1 3L6 7L10 1Z"
      fill={secondaryColor}
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
)
